/* ==========================================================================
   Scroll compatibility shim
   --------------------------------------------------------------------------
   Horizon does not scroll the document. It sets overflow:hidden on <html> and
   <body> and scrolls a .page-wrapper element instead. That means window.scrollY
   is always 0 and window.scrollTo() does nothing at all — silently, which is
   how it went unnoticed in the category panel and the careers page, where
   "scroll this into view" simply never happened.

   Rather than hunt every caller, this points the window-level API at the real
   scroller when the document is not the one scrolling. It also exposes
   window.GSScroll for new code, which is the better thing to call.

   If a future Horizon release goes back to scrolling the document, the guard
   below sees that and this file does nothing.
   ========================================================================== */

window.GSScroll = (function () {
  'use strict';

  function pick() {
    var doc = document.documentElement;
    var hidden = window.getComputedStyle(doc).overflowY === 'hidden' ||
      window.getComputedStyle(document.body).overflowY === 'hidden';
    if (!hidden) return null;
    var el = document.querySelector('.page-wrapper');
    if (el && el.scrollHeight > el.clientHeight + 4) return el;
    return null;
  }

  var box = pick();

  var api = {
    /* The element that actually scrolls, or the document when it is the one. */
    el: function () { return box || document.scrollingElement || document.documentElement; },
    y: function () { return box ? box.scrollTop : (window.pageYOffset || 0); },
    to: function (top, smooth) {
      var opts = { top: Math.max(0, top), behavior: smooth === false ? 'auto' : 'smooth' };
      try { api.el().scrollTo(opts); }
      catch (err) { api.el().scrollTop = Math.max(0, top); }
    },
    /* Listen for scrolling wherever it happens. */
    on: function (fn) {
      (box || window).addEventListener('scroll', fn, { passive: true });
    }
  };

  if (!box) return api;

  /* Make the window API work for code that already exists. */
  try {
    var nativeScrollTo = window.scrollTo.bind(window);

    window.scrollTo = function (a, b) {
      if (a && typeof a === 'object') { box.scrollTo(a); return; }
      if (typeof a === 'number' || typeof b === 'number') {
        box.scrollTo({ left: a || 0, top: b || 0 });
        return;
      }
      nativeScrollTo(a, b);
    };

    window.scrollBy = function (a, b) {
      if (a && typeof a === 'object') { box.scrollBy(a); return; }
      box.scrollBy({ left: a || 0, top: b || 0 });
    };

    Object.defineProperty(window, 'scrollY', { get: function () { return box.scrollTop; }, configurable: true });
    Object.defineProperty(window, 'pageYOffset', { get: function () { return box.scrollTop; }, configurable: true });
  } catch (err) {
    /* A browser that will not let us redefine these still gets window.GSScroll. */
  }

  return api;
})();
